var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FilterOptions"},_vm._l((_vm.options),function(option){return _c('button',{key:option.value,staticClass:"FilterOptions__option",class:{
      'FilterOptions__option--active': option.value === _vm.activeOption,
    },on:{"click":function($event){return _vm.setActiveOption(option)}}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }